import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { uploadS3ZoomProgress } from '../../actions/'

import Button from '@material-ui/core/Button'

import DescriptionIcon from '@material-ui/icons/Description'
import BrowserStore from 'store'
import LinearProgress from '@material-ui/core/LinearProgress'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },

  chip: {
    margin: theme.spacing(0.5)
  }
}))

class ZoomEventUpdateStepThree extends Component {
  render() {
    const { data, uploadRequest } = this.props

    let uploadingStatus = data.uploadS3DataLoading
    let textStatus = 'Uploading Please Wait'

    return (
      <React.Fragment>
        <p>
          {uploadingStatus == true ? (
            <LinearProgress />
          ) : (
            'Zoom process created, Zoom Links will update in a few minutes.  You can leave the page. '
          )}
        </p>

        <Grid container spacing={3}>
          {uploadingStatus == false ? (
            <div>
              {' '}
              <Button
                style={{
                  marginTop: '30px',
                  marginBottom: '30px'
                }}
                variant='outlined'
                size='large'
                color='primary'
                onClick={() => window.location.reload(false)}
              >
                Back to Home
              </Button>{' '}
            </div>
          ) : (
            <Button>Uploading..</Button>
          )}

          <div></div>
        </Grid>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.Zoom
})
const mapDispatchToProps = (dispatch) => ({
  uploadRequest: (status) => {
    dispatch(uploadS3ZoomProgress(status))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ZoomEventUpdateStepThree)
